import React from 'react'

export default function CustomerCard({ customerCode, name, points }) {
    return (
        <div className="bg-white rounded-lg shadow-md p-6 ">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-800">ข้อมูลสมาชิก</h2>
                <span className="bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full">
                    {customerCode}
                </span>
            </div>

            <div className="space-y-3">
                <div className="flex items-center">
                    {/* <i className="fa-solid fa-store"></i> */}
                    <img src='https://www.mkmedical.online:444/image_wheel_game/phamarcy-store.png?12345' alt='red-envelope' width={30} />
                    <div>
                        <p className="font-medium text-gray-800 ml-2" style={{ fontSize: 20 }}>{name}</p>
                    </div>
                </div>

                <div className="flex items-center">
                    {/* <i className="fa-solid fa-star"></i> */}
                    <img src='https://www.mkmedical.online:444/image_wheel_game/red-envelope.png?123' alt='red-envelope' width={29} />
                    <div>
                        <p className="font-medium text-green-600 ml-2" style={{ fontSize: 20 }}>{points.toLocaleString()} สิทธิ์ </p>
                        <span className=' ml-2' style={{ fontSize: 14, color: '#00000' }}> (สามารถใช้สิทธิ์ได้ถึง วันที่ 1 ก.พ. 68 เท่านั้น)</span>

                    </div>
                </div>
            </div>
        </div>
    )
}
